import styled from "styled-components"

import { color } from "../../../atoms/colors"
import BackgroundAsset from "../assets/stats-component-bg.png"

export const Section = styled.section`
  position: relative;
  width: 100%;
  padding: 40px 0px;
  @media (min-width: 769px) {
    padding: 56px 0px;
  }
  @media (min-width: 993px) {
    background-image: url(${BackgroundAsset}),
      linear-gradient(
        180deg,
        ${color.common.white} 0%,
        ${color.aliceBlue[50]} 100%
      );
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;
    padding: 96px 0px;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  /* max-width: 840px; */
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 0px auto;
  padding: 0px 45px;
  @media (min-width: 1170px) {
    max-width: 1230px;
    gap: 64px;
  }
`

export const Header = styled.div`
  width: 100%;
  max-width: 770px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  @media (min-width: 993px) {
    margin: unset;
  }
  .heading {
    font-weight: 900;
    font-size: 30px;
    line-height: 38px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${color.oxfordBlue[900]};
    margin: 0px;
    @media (min-width: 993px) {
      font-size: 36px;
      line-height: 44px;
      text-align: left;
    }
  }
  .subhead,
  .subhead p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${color.copy[700]};
    margin: 0px;
    @media (min-width: 992px) {
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }
    @media (min-width: 1170px) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`

export const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (min-width: 992px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  @media (min-width: 1170px) {
    gap: 40px;
  }
`

export const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .heading {
    font-weight: 800;
    font-size: 30px;
    line-height: 38px;
    color: ${color.secondary[900]};
    text-align: center;
    margin: 0px;
    @media (min-width: 992px) {
      text-align: left;
    }
    @media (min-width: 1170px) {
      font-size: 36px;
      line-height: 44px;
    }
  }
  .subhead {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${color.copy[700]};
    text-align: center;
    margin: 0px;
    @media (min-width: 992px) {
      font-size: 18px;
      line-height: 24px;
      text-align: left;
    }
    @media (min-width: 1170px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
`
